export const INIT_CALCULATOR = 'INIT_CALCULATOR';

export const initCalculator = (data) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: INIT_CALCULATOR,
                data: data,
            }),
        );
    };
};
